import React from 'react';
import { TrackingPropsInterface } from '@marriott/mi-ui-library';

export enum ATextInteractiveSize {
  XS = 'XS',
  S = 'S',
  M = 'M',
}

export interface ATextInteractiveProps extends React.HTMLAttributes<HTMLSpanElement | HTMLAnchorElement> {
  text: string;
  size?: ATextInteractiveSize;

  /** Link URL. Takes precedence over the deprecated `href` prop. */
  ctaLink?: string;
  /** @deprecated Prefer `ctaLink`. */
  href?: string;

  trackingProperties?: TrackingPropsInterface;
  custom_click_track_value?: string;
  preTrackVal?: string;
}
